import React from 'react';
import { Typography } from '@tvg/fuse/typography';
import { MarketingCard } from '@tvg/fuse/marketing-card';
import { getOfferEndDate } from 'utilities/date/date';
import styles from './CreditToAccountCard.module.css';

interface Props {
  offerTitle: string;
  voucherCode: string;
  endDate: string;
  onClickCallback: () => void;
}

function CreditToAccount(props: Props) {
  const { voucherCode, endDate, offerTitle, onClickCallback } = props;

  return (
    <MarketingCard
      className={styles.card}
      data-testid="credit-to-account-card"
      header={
        <Typography
          color="var(--color-brand-mid)"
          data-testid="credit-to-account-card-heading"
          size={{ xxs: '1', xl: '2' }}
          tag="h2"
          type="heading"
        >
          {offerTitle}
        </Typography>
      }
      paragraphText={
        <>
          <Typography
            data-testid="credit-to-account-card-text-1"
            size={{ xxs: 'm1', xl: '1' }}
            tag="p"
            type="paragraph"
          >
            Enter <strong>{voucherCode}</strong> at checkout to order on Buy Now Pay Later and get your credit back on
            this item.
          </Typography>

          <Typography
            data-testid="credit-to-account-card-text-2"
            size={{ xxs: 'm1', xl: '1' }}
            tag="p"
            type="paragraph"
          >
            Interest is calculated and compounded daily at a typical rate of 44.9% per annum for the delayed payment
            period and repayment period and is charged to your account at date of order as a lump sum.
          </Typography>

          <Typography
            data-testid="credit-to-account-card-text-3"
            size={{ xxs: 'm1', xl: '1' }}
            tag="p"
            type="paragraph"
          >
            <strong>Remember, avoid paying all interest</strong> by paying the cash price before the end of the delayed
            payment period. This can be done in one full payment or multiple partial payments.
          </Typography>

          <Typography data-testid="credit-to-account-card-end-date" size="m2" type="paragraph" tag="p">
            Offer ends {getOfferEndDate(endDate)}
          </Typography>
        </>
      }
      linkUrl="#"
      linkText="Find out more"
      onClick={onClickCallback}
    />
  );
}

export default CreditToAccount;
